'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultTo2 = require('lodash/fp/defaultTo');

var _defaultTo3 = _interopRequireDefault(_defaultTo2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initState = {
  config: {},
  entityType: {},
  doSignInAnon: false
};
var reducer = (0, _defaultTo3.default)(initState);
exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/cape-firebase/lib/reducer.js
// module id = 655
// module chunks = 0